"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2022 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerFactory = void 0;
const Customer_1 = require("./Customer");
const CustomerRequestHandler_1 = require("./requestHandlers/CustomerRequestHandler");
const VisitorData_1 = require("./VisitorData");
class CustomerFactory {
    constructor() {
        this.existingCustomer = null;
        this.awaitingTokenPromise = null;
    }
    /**
     * Overwrites the current customer
     * Should be handled with care because this would lead to loosing the event emitter.
     */
    clearCustomer() {
        this.existingCustomer = null;
    }
    /**
     * Returns the customer
     * @returns {Promise<Customer>}
     */
    getCustomer(isBroadcastAllowed) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.existingCustomer) {
                return this.existingCustomer;
            }
            if (this.awaitingTokenPromise) {
                yield this.awaitingTokenPromise;
                return this.existingCustomer;
            }
            this.awaitingTokenPromise = CustomerRequestHandler_1.CustomerRequestHandler.getToken();
            const visitorData = new VisitorData_1.VisitorData(yield this.awaitingTokenPromise);
            this.existingCustomer = Customer_1.Customer.create(visitorData, isBroadcastAllowed);
            this.awaitingTokenPromise = null;
            return this.existingCustomer;
        });
    }
    /**
     * Creates or updates a customer via `POST` based on the two  mandatory fields `email`,
     * `newsletterFlag`, and other optional parameters. optIn mail process will be started if
     * mandatory `newsletterFlag` param is toggled to true. Note: if customerId is given,
     * you can also update various properties with a `customer.updateProperties(..)` method call
     * @param shopId Sales channel id
     * @param params various params including mandatory fields: `email` and `newsletterFlag`
     */
    createOrUpdateCustomer(shopId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield CustomerRequestHandler_1.CustomerRequestHandler.createOrUpdateCustomer(shopId, params);
        });
    }
}
const customerFactory = new CustomerFactory();
exports.CustomerFactory = customerFactory;
